import Vue from 'vue'
import Router from 'vue-router'

// import Activity from '@/projects/activity'
import Temp from "@/projects/temp"
import Shop from "@/projects/shop"
import Cycling from "@/projects/cycling"
import My from "@/projects/my"
import Order from '../projects/order'
import CarShop from '@/projects/carShop'
Vue.use(Router)

export default new Router({
	mode: 'history',
	scrollBehavior(to, from, saveTop) {
		if (saveTop) {
			return saveTop
		} else {
			return { x: 0, y: 0 }
		}
	},
	routes: [
		// {
		//   path: '/',
		//   name: 'forgot-pass',
		//   component: ForgotPass,
		//   meta: {
		//     title: '首页',
		//     index: 0, // 用于路由跳转动画判断
		//   }
		// },
		// {
		// {
		// 	path: '/awaken',
		// 	name: 'awaken',
		// 	component: () => import('@/projects/activity/Awaken'),
		// 	meta: {
		// 		title: '骑行通',
		// 		index: 10,
		// 	}
		// },
		...Temp,
		...Shop,
		// ...Activity,
		...Cycling,
		...My,
		...Order,
		...CarShop,
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js